import { useEffect, useState } from "react";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import AssetCard, { AssetRow } from "@/components/AssetCard";
import AssetDetailModal from "@/components/AssetDetailModal";
import api from "@/lib/api";
import { useFavorites } from "@/contexts/FavoritesContext";
import { Heart } from "lucide-react";

export default function Favorites() {
  const { favSet, reload } = useFavorites();
  const [folders, setFolders] = useState([]);
  const [assets, setAssets] = useState([]);
  const [view, setView] = useState(() => localStorage.getItem("wd_view") || "grid");
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/folders").then((r) => setFolders(r.data));
    reload?.();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (favSet.size === 0) { setAssets([]); return; }
    api.get("/assets").then((r) => {
      setAssets(r.data.filter((a) => favSet.has(a.id)));
    });
  }, [favSet]);

  return (
    <div className="flex min-h-screen grain-overlay">
      <Sidebar folders={folders} onRefresh={() => api.get("/folders").then((r) => setFolders(r.data))} />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar view={view} setView={setView} onSearch={() => {}} searchValue="" onUpload={() => {}} canUpload={false} />
        <main className="flex-1 px-4 sm:px-6 md:px-10 lg:px-12 py-6 md:py-8 pb-20">
          <div className="mb-8">
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-1">Personal</div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight flex items-center gap-3">
              <Heart className="w-7 h-7 text-[var(--brand-accent)] fill-[var(--brand-accent)]" /> Favorites
            </h1>
            <p className="text-sm text-zinc-500 mt-1">{assets.length} {assets.length === 1 ? "video" : "videos"} hearted</p>
          </div>

          {assets.length === 0 ? (
            <div className="py-20 text-center">
              <Heart className="w-12 h-12 text-zinc-800 mx-auto mb-4" />
              <h3 className="font-heading text-xl font-semibold tracking-tight text-zinc-300">No favorites yet</h3>
              <p className="text-sm text-zinc-500 mt-1 max-w-sm mx-auto">Tap the heart on any video card to add it to your personal favorites.</p>
            </div>
          ) : view === "grid" ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {assets.map((a) => <AssetCard key={a.id} asset={a} onClick={() => setActive(a.id)} />)}
            </div>
          ) : (
            <div className="border-t border-zinc-900/60">
              {assets.map((a) => <AssetRow key={a.id} asset={a} onClick={() => setActive(a.id)} />)}
            </div>
          )}
        </main>
      </div>

      {active && (
        <AssetDetailModal assetId={active} onClose={() => setActive(null)} onChange={() => reload?.()} />
      )}
    </div>
  );
}
